<template>
  <div>
    <h5 class="title is-5">P.O. Request Excel Report</h5>
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Date from</label>
          <div class="control">
            <input
              type="date"
              v-model="poRequestDateRange.dateFrom"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Date to</label>
          <div class="control">
            <input
              type="date"
              v-model="poRequestDateRange.dateTo"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">&nbsp;</label>
          <div class="control">
            <b-button type="is-small" :loading="isFetching" @click="downloadPdf"
              >Download EXCEL File</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import AppToast from "../frontend/appToast";

const appToast = new AppToast();

export default {
  data: () => ({
    poRequestDateRange: {},
    isFetching: false,
  }),
  methods: {
    downloadPdf() {
      if (
        !this.poRequestDateRange.dateFrom ||
        !this.poRequestDateRange.dateTo
      ) {
        appToast.danger("Date from and/or Date to is empty");
        return false;
      }
      this.isFetching = true;
      axios
        .get(
          `downloadables/ExcelPoRequestByDateRange?dateFrom=${this.poRequestDateRange.dateFrom}&dateTo=${this.poRequestDateRange.dateTo}`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          console.log(response.data);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `P.O Request Report ${this.poRequestDateRange.dateFrom}-${this.poRequestDateRange.dateTo}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => (this.isFetching = false));
    },
  },
};
</script>
